module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "departmentList"
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "storeListSearch": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.departmentList,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetLocalizedDateFromUTC(props.item.created_on)))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('DEPARTMENTAL_MODULE') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowEdit(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('DEPARTMENTAL_MODULE') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDepartmentDelete(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]) : _vm._e()])]
      }
    }])
  })], 1)
},staticRenderFns: []}